var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourGlassMediumIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7L3.675 4.50625C3.62066 4.4655 3.57656 4.41265 3.54619 4.35191C3.51581 4.29116 3.5 4.22417 3.5 4.15625V2.1875C3.5 2.07147 3.54609 1.96019 3.62814 1.87814C3.71019 1.79609 3.82147 1.75 3.9375 1.75H10.0625C10.1785 1.75 10.2898 1.79609 10.3719 1.87814C10.4539 1.96019 10.5 2.07147 10.5 2.1875V4.13663C10.5 4.20427 10.4843 4.27099 10.4542 4.33155C10.424 4.3921 10.3803 4.44485 10.3263 4.48564L7 7Z",
    stroke: "#909599",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7L3.675 9.49375C3.62066 9.5345 3.57656 9.58734 3.54619 9.64809C3.51581 9.70884 3.5 9.77583 3.5 9.84375V11.8125C3.5 11.9285 3.54609 12.0398 3.62814 12.1219C3.71019 12.2039 3.82147 12.25 3.9375 12.25H10.0625C10.1785 12.25 10.2898 12.2039 10.3719 12.1219C10.4539 12.0398 10.5 11.9285 10.5 11.8125V9.86337C10.5 9.79573 10.4843 9.72901 10.4542 9.66845C10.424 9.6079 10.3803 9.55515 10.3263 9.51436L7 7Z",
    stroke: "#909599",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08203 4.8125H9.89325",
    stroke: "#909599",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.18725V7",
    stroke: "#909599",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlassMediumIcon);
export default __webpack_public_path__ + "static/media/hour-glass-medium-icon.2bd880c0.svg";
export { ForwardRef as ReactComponent };